import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogVariantOptions } from 'shared/assets/styles';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './confirm-dialog.style';

export type ConfirmDialogProps = {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
};

// Only for synchronous yes/no confirmations — dialogs with pending state,
// extra inputs, or a third option stay bespoke.
export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      variant={DialogVariantOptions.ExtraSmall}
    >
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {title}
        </Typography>
      </Styled.Header>

      <Styled.Body>
        <Typography variant="body2">{message}</Typography>
      </Styled.Body>

      <Styled.Interactions>
        <Button
          variant={Variants.Contained}
          size={Sizes.Medium}
          color={Colors.White}
          onClick={onCancel}
        >
          {cancelLabel ?? t('general.cancel')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onConfirm}>
          {confirmLabel ?? t('general.delete')}
        </Button>
      </Styled.Interactions>
    </Dialog>
  );
};
